import { render, staticRenderFns } from "./CartIcon.vue?vue&type=template&id=32aee448&scoped=true&"
var script = {}
import style0 from "./CartIcon.vue?vue&type=style&index=0&id=32aee448&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aee448",
  null
  
)

export default component.exports